// import apiTypeMenuSvg from '../assets/img/help-doc.png'
// import apiSafetyCenterMenuSvg from '../assets/img/anquanzhongxin.png'
 import api2 from '../assets/img/api2.0.png'
 import api1 from '../assets/img/api1.0.png'
 import nquan1 from '../assets/img/anquan1.0.png'
export default {
  apiTypeMenu: {
    chName: '接口文档',
    img: api1
  },
  apiTypeMenu2: {
    chName: '接口文档',
    img: api2
  },
  apiSafetyCenterMenu: {
    chName: '安全中心',
    img: nquan1
  }
}



// WEBPACK FOOTER //
// ./src/utils/translation.js